import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import {initDB} from "@/db";
//import { FirebaseAuthPlugin } from "@/plugins/FirebaseAuthPlugin";
import "firebaseui/dist/firebaseui.css";
import "./evoluq_sass/evoluq_materialize.scss";
import i18n from './i18n'
import Vuelidate from "vuelidate";

Vue.use(Vuelidate);
initDB(store);

import { SegmentAnalytics } from '@segment/analytics.js-core';

declare global {
  interface Window {
    analytics: SegmentAnalytics.AnalyticsJS;
  }
}

Vue.mixin({
  data: function() {
    return {
      get globalStudentApplyUrl() {
        return process.env.VUE_APP_APPLY_URL;
      }
    }
  }
})

//Vue.use(FirebaseAuthPlugin);
Vue.config.productionTip = true;

Vue.filter('truncate', function (text: string, stop: number, clamp: string) {
  return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '')
})

new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
  validations: {}
}).$mount("#app");
